<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">Commands</h1>
    <div class="mb-6 flex justify-between items-center">
      <search-filter v-model="form.search" class="w-full max-w-md mr-4" @reset="reset">
        <label class="block text-gray-700">Trashed:</label>
        <select v-model="form.trashed" class="mt-1 w-full form-select">
          <option :value="null" />
          <option value="with">With Trashed</option>
          <option value="only">Only Trashed</option>
        </select>
      </search-filter>
      <inertia-link class="btn-indigo" :href="route('commands.create')">
        <span>Add</span>
        <span class="hidden md:inline">Command</span>
      </inertia-link>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="px-6 pt-6 pb-4">Enabled</th>
          <th class="px-6 pt-6 pb-4">Name</th>
          <th class="px-6 pt-6 pb-4">Reply</th>
          <th class="px-6 pt-6 pb-4">Mention User</th>
          <!--
          <th class="px-6 pt-6 pb-4">Stream Title Hashtags</th>
          <th class="px-6 pt-6 pb-4">Stream Tags</th>
          <th class="px-6 pt-6 pb-4">Stream Category</th>
          -->
        </tr>
        <tr v-for="command in commands.data" :key="command.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('commands.edit', command.id)" tabindex="-1">
              {{ command.is_enabled == true ? "🟢" : "🔴" }}
            </inertia-link>
          </td>
           <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center focus:text-indigo-500" :href="route('commands.edit', command.id)">
              {{ command.command_name }}
              <icon v-if="command.deleted_at" name="trash" class="flex-shrink-0 w-3 h-3 fill-gray-400 ml-2" />
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-2 flex items-center" :href="route('commands.edit', command.id)" tabindex="-1">
                <index-preview :preview_message='truncate(command.command_reply)' />
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('commands.edit', command.id)" tabindex="-1">
              {{ command.mention_user == true ? "Yes" : "No" }}
            </inertia-link>
          </td>
          <!--
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('commands.edit', command.id)" tabindex="-1">
              {{ command.stream_title_hashtag }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('commands.edit', command.id)" tabindex="-1">
              {{ command.stream_tags }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('commands.edit', command.id)" tabindex="-1">
              {{ command.stream_game }}
            </inertia-link>
          </td>
          -->
          <td class="border-t w-px">
            <inertia-link class="px-4 flex items-center" :href="route('commands.edit', command.id)" tabindex="-1">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
            </inertia-link>
          </td>
        </tr>
        <tr v-if="commands.data.length === 0">
          <td class="border-t px-6 py-4" colspan="7">No commands found.</td>
        </tr>
      </table>
    </div>
    <pagination class="mt-6" :links="commands.links" />
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'
import IndexPreview from '../../Shared/IndexPreview.vue'

export default {
  metaInfo: { title: 'Commands' },
  components: {
    Icon,
    Pagination,
    SearchFilter,
    IndexPreview,
  },
  layout: Layout,
  props: {
    filters: Object,
    commands: Object,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        trashed: this.filters.trashed,
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function() {
        this.$inertia.get(this.route('commands'), pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  computed: {
    nodes(message) {
        console.log(message)
        return message.split(' ')
    }
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
    truncate(data) {
        var truncated;
        truncated = data.split(" ").slice(0, 20).join(" ") + " (...)";
      if(truncated > 80){
        truncated =  truncated.split(" ").slice(0, 15).join(" ") + "(...)";
      }
      return data;
    }
  },
}
</script>
